document.addEventListener("DOMContentLoaded", function(event) { 
    const container = document.querySelector('.js-detail-share')

    if (container) {
        const metaOgTitle = document.querySelector('meta[property="og:title"]')
        const metaOgDescr = document.querySelector('meta[property="og:description"]')
        let description = ''
        if (document.querySelector('meta[name="description"]')) {
            description = document.querySelector('meta[name="description"]').getAttribute('content')
        }
        if (document.querySelector('meta[property="og:description"]')) {
            description = document.querySelector('meta[property="og:description"]').getAttribute('content')
        }

        let image = ''

        if (document.querySelector('meta[property="og:image"]')) {
            image = document.querySelector('meta[property="og:image"]').getAttribute('content')
        }

        const share = Ya.share2(container, {
            content: {
                // url: window.location.href,
                title: metaOgTitle ? metaOgTitle.getAttribute('content') : document.title,
                description: description ,
                image: image
            }
        })
    }
});




// WEBPACK FOOTER //
// ./frontend/components/detail-share/detail-share.js